var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 20.7H1.7c-.7 0-1.3-.6-1.3-1.3V6.7c0-.7.6-1.3 1.3-1.3h6.7c.6 0 1.2.6 1.2 1.3v12.8c0 .6-.6 1.2-1.3 1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 20.2H1.7c-.7 0-1.3-.6-1.3-1.3V6.7c0-.7.6-1.3 1.3-1.3h6.7c.6 0 1.2.6 1.2 1.3V19c0 .6-.6 1.2-1.3 1.2zM8.2 1.8S6.7.4 5 .4C3.3.4 1.8 1.8 1.8 1.8M7.1 3.1s-1-1-2.1-1c-1.1.1-2.1 1-2.1 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 19.9H1.7c-.7 0-1.3-.6-1.3-1.3V6.7c0-.7.6-1.3 1.3-1.3h6.7c.6 0 1.2.6 1.2 1.3v11.9c0 .7-.6 1.3-1.3 1.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 20.2,
    rx: 0.4,
    ry: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPhoneIcon);
export default __webpack_public_path__ + "static/media/cell-phone-icon.4dbf5082395484ad3e588854f747cd70.svg";
export { ForwardRef as ReactComponent };